import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subscriberCheckbox", "analystSelect"]

  connect() {
    this.toggleAnalystSelect()
  }

  toggleAnalystSelect() {
    if (this.subscriberCheckboxTarget.checked) {
      this.analystSelectTarget.classList.remove("hidden")
    } else {
      this.analystSelectTarget.classList.add("hidden")
    }
  }
}
